module.exports = __webpack_public_path__ + "static/img/banner2.abf85414.png";